import React, { useState, useEffect } from 'react';
import { useFirestoreCollection } from '../../../hooks/useFirestoreCollection';
import { useFirestoreDoc } from '../../../hooks/useFirestoreDoc';
import { useNotifications } from "../../../utils/NotificationContext/NotificationContext";
import { HiChevronLeft, HiChevronRight, HiWallet  } from 'react-icons/hi2';
import { updateDoc, doc } from 'firebase/firestore';
import { db } from '../../../firebase/firebase';
import { useAuth } from "../../../utils/AuthContext/authcontext";
import styles from './TransactionHistoryTab.module.css';
import { useTranslation } from 'react-i18next';
import Button from '../../ui/Button';

const ITEMS_PER_PAGE = 5;

export default function TransactionHistoryTab({ user }) {
  const { items, loading, error } = useFirestoreCollection(`users/${user.uid}/transactions`, 'createdAt');
  const {searchbyUsersId} = useAuth();
  const [historyItems, setHistoryItems] = useState([]);
  const [filter, setFilter] = useState('all');
  const { t } = useTranslation();
  const [page, setPage] = useState(1);

  const filtered = historyItems.filter(tx => filter === 'all' || tx.type === filter);
  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const paginated = filtered.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);

  useEffect(() => {
      const fetchUserData = async () => {
		let data = await Promise.all(items.map(async (requestId) => {
			var user = [];
			if(requestId?.fromUser?.length > 0) {
				const users = await searchbyUsersId(requestId?.fromUser);
				requestId.fromUser = users[0].username;
				return requestId;
			}
			else if(requestId?.toUser?.length > 0) {
				const users = await searchbyUsersId(requestId?.toUser);
				requestId.toUser = users[0].username;
				return requestId;
			}
		}))
		setHistoryItems(data);
      };
      fetchUserData();
  }, [items]);

  const changePage = (dir) => setPage(prev => Math.max(1, Math.min(prev + dir, totalPages)));

  if (loading) return <div className={styles.message}>{t('transactions.loading')}</div>;
  if (error) return <div className={styles.error}>{t('transactions.error', { error: error.message })}</div>;

  return (
    <div className={styles.wrapper}>
      <div className={styles.background}></div>

      <div className={styles.container}>
        <aside className={styles.summary}>
          <h3 className={styles.title}>{t('history.title')}</h3>
          <p className={styles.text}>{t('history.summary')}</p>

          <div className={styles.filters}>
            {['all', 'sent', 'received', 'buy'].map(type => (
              <Button variant={'ghost'}
                key={type}
                className={`${styles.filterButton} ${filter === type ? styles.active : ''}`}
                onClick={() => {
                  setFilter(type);
                  setPage(1);
                }}
              >
                {t(`history.filter.${type}`)}
              </Button>
            ))}
          </div>
        </aside>

        <section className={styles.tableSection}>
          <div className={styles.tableContainer}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>{t('history.date')}</th>
                  <th>{t('history.action')}</th>
                  <th>{t('history.amount')}</th>
                  <th>{t('history.counterparty')}</th>
                </tr>
              </thead>
              <tbody>
                {paginated.length > 0 ? (
                  paginated.map(tx => (
                    <tr key={tx.txid}>
                      <td>{new Date(tx.createdAt.toDate()).toLocaleDateString()} - {new Date(tx.createdAt.toDate()).toLocaleTimeString()}</td>
                      <td>{tx.type}</td>
                      <td>{tx.amount.toFixed(2)} RTC</td>
                      <td>{tx.fromUser || tx.toUser || '�'} <br/><div className={styles.walletstyle} > <HiWallet/> {tx.fromAddress || tx.toAddress}</div></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className={styles.message}>
                      {t('history.empty')}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className={styles.pagination}>
            <Button variant={'secondary'} onClick={() => changePage(-1)} disabled={page === 1}>
              <HiChevronLeft />
            </Button>
            <span>{page} / {totalPages || 1}</span>
            <Button variant={'secondary'} onClick={() => changePage(1)} disabled={page === totalPages}>
              <HiChevronRight />
            </Button>
          </div>
        </section>
      </div>
    </div>
  );
}

